import React from 'react';
import { Helmet } from 'react-helmet';

import { HEADER_CONSTANTS } from '../utilities/constants';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';
import { useViewportSize } from '../utilities/useViewPort';

import { FieldBulletinBoardDetailProvider } from '../services/fieldBulletinBoard/FieldBulletinBoardDetailContext';
import { FieldBulletinBoardDetailForPrime } from '../components/fieldBulletinBoard/FieldBulletinBoardDetailForPrime';
import { FieldBulletinBoardsHeaderDetailForPrime } from '../components/fieldBulletinBoard/FieldBulletinBoardsHeaderDetailForPrime';
import { FieldBulletinBoardDetailForPartner } from '../components/fieldBulletinBoard/FieldBulletinBoardDetailForPartner';
import { FieldBulltinBoardDetailHeaderForPartner } from '../components/fieldBulletinBoard/FieldBulletinBoardDetailHeaderDetailForPartner';

import Styles from '../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardDetail.scss';

export function FieldBulletinBoardDetail({ view }) {
  const { viewportHeight } = useViewportSize();
  
  return (
    <FieldBulletinBoardDetailProvider
      fieldBulletinBoardId={view.state.id}
      fieldBulletinBoardSearchParam={view.state.fieldBulletinBoardSearchParam}
    >
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {data.title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <div className={`${Styles.detailMain}`} style={{height: `${viewportHeight}px`}}>
            {isPrimaryCompanyRoleId(LocalStorageService.getRoleId()) ? (
              <React.Fragment>
                <FieldBulletinBoardsHeaderDetailForPrime />
                <FieldBulletinBoardDetailForPrime />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <FieldBulltinBoardDetailHeaderForPartner />
                <FieldBulletinBoardDetailForPartner />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </FieldBulletinBoardDetailProvider>
  );
}

const data = {
  title: 'お知らせ詳細',
};



// WEBPACK FOOTER //
// ./src/pages/FieldBulletinBoardDetail.jsx